import React from 'react';

import ProductPackageAdderButton from '@src/components/ProductPackage/ProductPackageAdderButton';
import PackageBookingModal from '@src/components/ProductPackage/PackageBookingModal';
import ProductAdderButton from './ProductAdderButton';
import ProductAdderRoot from './ProductAdderRoot';

const ProductAdderComponentSwitcher = (props: { showAsModal: boolean; packageId?: string }) => {
  const { showAsModal, packageId } = props;

  if (packageId) {
    return showAsModal ? <ProductPackageAdderButton /> : <PackageBookingModal />;
  }

  return showAsModal ? <ProductAdderButton /> : <ProductAdderRoot />;
};

export default ProductAdderComponentSwitcher;
